<template>
  <div>
    <div :class="`${el}__row`">
      <div :class="`${el}__content`">
        <InViewAnimation>
          <Headline slot="0" size="m" centered noMargin>
            {{ $t('careLevelCalculator.start.headline') }}
          </Headline>
        </InViewAnimation>
        <Row :class="`${el}__contentInner`">
          <Col :xs="12" :s="8" :sOffset="2" :l="4" :lOffset="2" center>
            <InViewAnimation :delay="2">
              <Illustration
                slot="0"
                :class="`${el}__illustration`"
                name="teaser-5"
                brushColor="primaryCoral"
                :brush="5"
                :brushScale="$matchMedia.l ? 0.8 : 1"
              />
            </InViewAnimation>
          </Col>
          <Col :xs="12" :s="8" :sOffset="2" :l="4" :lOffset="0">
            <CareLevelChecker reduced />
          </Col>
        </Row>
      </div>
    </div>

    <Divider dotted />

    <div :class="`${el}__row ${el}__buttonRow`">
      <Link icon="arrow-left-line" :class="`${el}__navLink`" @click="prevPage" noUnderline>
        {{ $t('careLevelCalculator.backButton') }}
      </Link>

      <Button
        :label="$t('careLevelCalculator.nextButton')"
        additionalIconName="arrow-right-line"
        @click="nextStep"
        :expand="!$matchMedia.s"
        :disabled="
          careLevelSituation === null ||
          (careLevelSituation === 1 && !hasCareLevel) ||
          (careLevelSituation === 0 && !hasCareLevel)
        "
        small
      />
    </div>
  </div>
</template>

<script>
import Headline from '@/objects/Headline';
import Illustration from '@/objects/Illustration';
import Link from '@/objects/Link';
import Divider from '@/objects/Divider';
import Button from '@/objects/Button';
import Row from '@/components/Grid/Row';
import Col from '@/components/Grid/Col';
import InViewAnimation from '@/components/InViewAnimation';
import CareLevelChecker from '@/components/CareLevelChecker';
import Tracking from '@/helpers/tracking/Tracking';

import {
  ROUTE_SERVICE_CARELEVEL_CALCULATOR_PREWIZARD,
  ROUTE_SERVICE_CARELEVEL_CALCULATOR_WIZARD,
} from '@/constants/routes';

import { SS_CARE_LEVEL_CALCULATOR_PREWIZARD_STEP2_RELOADED } from '@/constants/storage';

import { mapFieldsHealth } from '@/store/mapFields';

export default {
  name: 'Step2',
  components: {
    Headline,
    Link,
    Divider,
    Illustration,
    Button,
    Row,
    Col,
    InViewAnimation,
    CareLevelChecker,
  },
  computed: {
    ...mapFieldsHealth(['careLevelSituation', 'careLevel', 'dependentPerson']),

    hasCareLevel() {
      return this.careLevel !== null;
    },
  },
  data() {
    return {
      el: 'v-careLevelCalculatorPreWizard',
      classes: () => {
        const el = this.el;
        return {
          [el]: true,
        };
      },
    };
  },
  mounted() {
    // Skip only if this document was actually reloaded and we set the flag ourselves
    if (sessionStorage.getItem(SS_CARE_LEVEL_CALCULATOR_PREWIZARD_STEP2_RELOADED)) {
      sessionStorage.removeItem(SS_CARE_LEVEL_CALCULATOR_PREWIZARD_STEP2_RELOADED);
    } else {
      sessionStorage.setItem(SS_CARE_LEVEL_CALCULATOR_PREWIZARD_STEP2_RELOADED, 'true');
      this.$router.go();
    }
    Tracking.disableTracking();
  },
  methods: {
    prevPage() {
      this.$router.push(ROUTE_SERVICE_CARELEVEL_CALCULATOR_PREWIZARD);
    },
    nextStep() {
      this.$router.push(ROUTE_SERVICE_CARELEVEL_CALCULATOR_WIZARD);
    },
  },
};
</script>
